/**
 * The catalog's product categories and how the site names them.
 *
 * `stock.product_category` is a plain string on the backend; this is the
 * one place the site turns it into words. GPU and TCG were the only two for
 * a year, and "GPU" leaked into copy as the default noun for anything that
 * was not a card game. The 2026-09 expansion added memory, storage and
 * processors (DRAM and NAND shortages, X3D chips), so the noun comes from
 * here now.
 */
export const PRODUCT_CATEGORIES = ['GPU', 'RAM', 'SSD', 'CPU', 'MAC', 'CONSOLE', 'TCG'];

export const CATEGORY_LABELS = {
    GPU: 'Graphics Cards',
    RAM: 'Memory',
    SSD: 'Storage',
    CPU: 'Processors',
    MAC: 'Macs',
    CONSOLE: 'Consoles',
    TCG: 'Pokemon TCG'
};

/** What to call one item of the category in a sentence ("Untrack GPU", "Track this SSD"). */
export const CATEGORY_NOUNS = {
    GPU: 'GPU',
    RAM: 'memory kit',
    SSD: 'SSD',
    CPU: 'CPU',
    MAC: 'Mac',
    CONSOLE: 'Console',
    TCG: 'product'
};

export const categoryNoun = (category) => CATEGORY_NOUNS[String(category || 'GPU').toUpperCase()] || 'product';

/** Title-case noun for page titles: "GPU Stock Tracker", "SSD Stock Tracker", "Product Stock Tracker". */
export const categoryTitleNoun = (category) => {
    const noun = categoryNoun(category);
    return noun === 'product' ? 'Product' : noun === 'memory kit' ? 'Memory Kit' : noun;
};
